<template>
  <div class="acomodar">
    <button class="btn btn-danger" style="align-self: flex-start; margin-left: 10px; margin-top: 10px;" @click="$router.push(`/bienvenido`)">
      <i class="bi bi-skip-backward"></i>
    </button>

    <div class="header-titulo">
      <h2>VIDEOS DE REFERENCIA</h2>
  
    </div>

    <div class="video-grid">
      <div v-for="(video, index) in videos" :key="index" class="video-card">
        <h3 class="video-title">{{ titulos[index] }}</h3>
        <div class="video-body">
          <!-- Botón visual -->
          <div class="video-icon" @click="openFullscreen(index)">
            <img src="@/assets/logo-you.png" alt="youtube" class="mb-2" style="width: 90px; height: 70px;" />
            <p class="label">VISUALIZAR VIDEO</p>
          </div>

          <!-- Video player -->
          <div class="video-wrapper">
            <iframe
              v-if="isYouTube(video)"
              :ref="'video' + index"
              :src="getYouTubeEmbedUrl(video)"
              frameborder="0"
              allowfullscreen
            ></iframe>
            <video
              v-else
              controls
              :ref="'video' + index"
            >
              <source :src="video" type="video/mp4" />
              Tu navegador no soporta el video.
            </video>
          </div>
        </div>
        
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MisVideos",
  data() {
    return {
      videos: [
        "https://www.youtube.com/watch?v=yVHG_lFs8Cc",
        "https://www.youtube.com/watch?v=Nh6xRiULyAA",
        "https://www.youtube.com/watch?v=yfzWGk0IyL0",
        "https://www.youtube.com/watch?v=QgyfQ65FD-E"
      ],
      titulos: [
        "",
        ""
      ]
    };
  },
  methods: {
    isYouTube(url) {
      return url.includes("youtube.com") || url.includes("youtu.be");
    },
    getYouTubeEmbedUrl(url) {
      try {
        let videoId = null;
        if (url.includes("youtube.com")) {
          const urlParams = new URLSearchParams(new URL(url).search);
          videoId = urlParams.get("v");
        } else if (url.includes("youtu.be")) {
          videoId = url.split("youtu.be/")[1]?.split("?")[0];
        }
        return videoId ? `https://www.youtube.com/embed/${videoId}` : "";
      } catch (error) {
        console.error("Error al obtener el ID del video de YouTube:", error);
        return "";
      }
    },
    openFullscreen(index) {
      const videoElement = this.$refs['video' + index];
      const el = Array.isArray(videoElement) ? videoElement[0] : videoElement;

      if (el && el.requestFullscreen) el.requestFullscreen();
      else if (el && el.webkitRequestFullscreen) el.webkitRequestFullscreen();
      else if (el && el.mozRequestFullScreen) el.mozRequestFullScreen();
      else if (el && el.msRequestFullscreen) el.msRequestFullscreen();
      else alert("Tu navegador no permite pantalla completa.");

      if (el && typeof el.play === 'function') el.play();
    }
  }
};
</script>

<style scoped>
.acomodar {
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  margin-top: 1%;
  margin-bottom: 1%;
  width: 100%;
  background: rgb(255, 255, 255);
  margin-left:1%;
  margin-right: 1%;
  height: auto;
  padding-bottom: 20px;
  border-radius: 10px 10px 10px 10px;
  overflow-x: hidden;
  overflow-y: none;
}

.header-titulo {
  border: 1px solid #ccc;
  padding: 10px 20px;
  margin: 20px;
  text-align: left;
}

.header-titulo h2 {
  margin: 0;
  font-weight: bold;
  font-size: 22px;
}

.subtitulo {
  color: #7a7a7a;
  font-weight: 600;
  font-size: 16px;
  margin-top: 5px;
}

.video-grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
  padding: 0 20px;
}

.video-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  padding: 15px;
  width: 340px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.video-title {
  font-size: 15px;
  font-weight: bold;
  margin-bottom: 10px;
  text-align: center;
}

.video-body {
  display: flex;
  align-items: center;
  gap: 10px;
}

.video-icon {
  width: 80px;
  height: 80px;
  background: #f5f5f5;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 6px;
}

.video-icon img {
  width: 45px;
  height: 45px;
}

.label {
  font-size: 11px;
  font-weight: bold;
  text-align: center;
  margin-top: 5px;
}

.video-wrapper iframe,
.video-wrapper video {
  width: 220px;
  height: 130px;
  border-radius: 8px;
  border: 1px solid #ccc;
}

.exam-status {
  margin-top: 12px;
  font-size: 13px;
  font-weight: 600;
  color: #4a4a4a;
  border: 1px solid #ddd;
  padding: 5px 10px;
  border-radius: 5px;
}

/* Responsive */
@media (max-width: 768px) {
  .video-grid {
    flex-direction: column;
    align-items: center;
  }

  .video-card {
    width: 90%;
  }
}
</style>
